import axios from "../axios";
import { type PresetConfigTypes } from "../../state/calculations/calculations.types";
import { AxiosResponse } from "axios";

const estimator = {
  submit: async (data: any): Promise<void> => {
    const payload = new FormData();
    payload.append("file", data?.file);
    payload.append("selectedPolymers[]", data?.polymer);
    payload.append("copies", data?.numberOfCopies);
    payload.append("clean", data?.clean);
    if (data?.layers) {
      payload.append("Layers", data?.layers);
    }
    payload.append("MarkAllImage", data?.markAllImage);
  }
};

export default estimator;
